@import '~style-sheet-helpers/core.less';
@import '../../../app-brand//entities/entity-layer.module.less';

.modal-body {
  padding: 16px;
  height: 300px;
}

.modal-body-text {
  font-size: 14px;
  line-height: 18px;
}

.modal-body-dropdown {
  font-size: 14px;
  line-height: 18px;
  width: 350px;
}

.dropdown-header {
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  margin: 0 0 0.5em 0.2em;
}

.dropdown-menu {
  width: 350px;
}

.info-wrapper {
  display: flex;
  max-width: 580px;
  border-radius: 5px;
  font-size: 12px;
  background-color: @banner-message--info--background-color;
  margin: 10px 0 0;

  svg {
    margin: 8px 0 0 13px;
    height: 16px;
    width: 16px;
    fill: @banner-message--info--fill-color;
  }

  .message {
    overflow: hidden;
    grid-column: 1 / span 3;
    padding: 10px;
    justify-content: space-around;
  }
}
